import { Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ConfigSystemParams, msSize } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { formatInventoryDate, getInventoryStatusStyle } from 'src/app/core/functions-generic/functions-generic-inventory';
import { InventoryDeviceDetailDTO, InventoryDeviceDetailDTO_EmptyObject } from 'src/app/core/models/system/inventory/inventory.dto';
import { InventoryService } from 'src/app/core/services/utelize/system/inventory/inventory-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-inventory-asset-modal-form',
  templateUrl: './inventory-asset-modal-form.component.html',
  styleUrls: ['./inventory-asset-modal-form.component.scss']
})

export class InventoryAssetModalFormComponent implements OnInit, OnDestroy {

  @Output() formCancelled: EventEmitter<void>=new EventEmitter<void>();

  @ViewChild('inventoryAssetModalForm', { static: false }) inventoryAssetModalForm!: TemplateRef<void>;

  get modalBackGround(): boolean | 'static' {
    try {
      const value=(this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE") ?? "TRUE").toUpperCase();

      return value==="STATIC" ? "static" : value==="TRUE";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  }

  private deviceSub: Subscription | undefined;
  private modalRef : NgbModalRef  | undefined;

  public assetId  : string="";
  public device   : InventoryDeviceDetailDTO=InventoryDeviceDetailDTO_EmptyObject();
  public isLoading: boolean=false;
  public loadError: string="";

  constructor(
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService,
    private inventoryService   : InventoryService,
    private modalService       : NgbModal
  ) { }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.deviceSub?.unsubscribe();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private loadDevice(companyId: number): void {
    try {
      this.deviceSub?.unsubscribe();
      this.isLoading=true;
      this.loadError="";

      this.deviceSub=this.inventoryService.getDeviceByAssetId(companyId, this.assetId)
        .subscribe({
          next : data  => {
            this.device   =data ?? InventoryDeviceDetailDTO_EmptyObject();
            this.isLoading=false;
          },
          error: error => {
            this.isLoading=false;
            this.loadError="The asset details could not be loaded.";
            this.exceptionsService.handleException(new Error(error));
          }
        });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public cancelForm(): void {
    try {
      this.deviceSub?.unsubscribe();
      this.formCancelled.emit();
      this.modalRef?.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public display(value: string | null | undefined): string {
    try {
      return value==null || value.trim()==="" ? "-" : value;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "-";
    }
  }

  public formatDate(value: string | null | undefined): string {
    try {
      return formatInventoryDate(this.exceptionsService, value) || "-";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "-";
    }
  }

  public openForm(companyId: number, assetId: string): void {
    try {
      this.assetId=assetId;
      this.device =InventoryDeviceDetailDTO_EmptyObject();

      this.modalRef=this.modalService.open(this.inventoryAssetModalForm, {
        backdrop: this.modalBackGround,
        centered: true,
        keyboard: false,
        size    : msSize.Large
      });

      this.loadDevice(companyId);
    }
    catch(e) {
      this.formCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public statusColour(status: string | null | undefined): string {
    try {
      return getInventoryStatusStyle(this.exceptionsService, status).colour;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'secondary';
    }
  }

  public statusIcon(status: string | null | undefined): string {
    try {
      return getInventoryStatusStyle(this.exceptionsService, status).icon;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'ri-question-line';
    }
  }

  public statusLabel(status: string | null | undefined): string {
    try {
      return this.display(status);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return this.display(status);
    }
  }
}
